import { render, staticRenderFns } from "./textDocument.vue?vue&type=template&id=22ca6d2e&scoped=true"
import script from "./textDocument.vue?vue&type=script&lang=js"
export * from "./textDocument.vue?vue&type=script&lang=js"
import style0 from "./textDocument.vue?vue&type=style&index=0&id=22ca6d2e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ca6d2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22ca6d2e')) {
      api.createRecord('22ca6d2e', component.options)
    } else {
      api.reload('22ca6d2e', component.options)
    }
    module.hot.accept("./textDocument.vue?vue&type=template&id=22ca6d2e&scoped=true", function () {
      api.rerender('22ca6d2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/industryChainNew/components/textDocument.vue"
export default component.exports